import { render, staticRenderFns } from "./CostCentre.vue?vue&type=template&id=64884e1c&scoped=true&"
import script from "./CostCentre.vue?vue&type=script&lang=js&"
export * from "./CostCentre.vue?vue&type=script&lang=js&"
import style0 from "./CostCentre.vue?vue&type=style&index=0&id=64884e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64884e1c",
  null
  
)

export default component.exports